import React from 'react';

export default function Nosotros() {
  return (
    <section className="section page-section about-page">
      <div className="section-header">
        <h1>Sobre MisXV.com.mx</h1>
        <p>Conectamos a las familias mexicanas con los mejores proveedores para la fiesta de XV años.</p>
      </div>
      <div className="about-content">
        <img src="https://picsum.photos/seed/nosotros/900/450" alt="Equipo MisXV" className="about-image" />
        <h2>Nuestra misión</h2>
        <p>
          Facilitar la organización de la fiesta de XV años más importante de la vida de cada
          quinceañera, dando a las familias un solo lugar confiable donde comparar, cotizar y
          contratar salones, vestidos, academias de baile, barras, entretenimiento, maquillistas,
          limosinas, cabinas fotográficas y mucho más.
        </p>
        <h2>Lo que nos hace diferentes</h2>
        <ul className="benefits-list">
          <li>✔ Proveedores verificados con reseñas reales</li>
          <li>✔ Cotización simultánea con varios proveedores</li>
          <li>✔ Guarda tus favoritos y compáralos fácilmente</li>
          <li>✔ Contacto directo por WhatsApp</li>
          <li>✔ Contenido y consejos de expertos en XV años</li>
        </ul>
      </div>
    </section>
  );
}
